// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {

  if (!values.carTripImage1 || !values.carTripImage2) {
    showToaster({ messageId: 'blockSettingsFailed', toasterType: 'error' })
    return;
  }

  const mutation = `
    mutation (
        $carTripTitle1: String,
        $carTripTitle1_en: String,
        $carTripTitle1_fr: String,
        $carTripTitle1_it: String,
        $carTripTitle1_pt: String,
        $carTripTitle2: String,
        $carTripTitle2_en: String,
        $carTripTitle2_fr: String,
        $carTripTitle2_it: String,
        $carTripTitle2_pt: String,
        $carTripContent2: String,
        $carTripContent2_en: String,
        $carTripContent2_fr: String,
        $carTripContent2_it: String,
        $carTripContent2_pt: String,
        $carTripTitle3: String,
        $carTripTitle3_en: String,
        $carTripTitle3_fr: String,
        $carTripTitle3_it: String,
        $carTripTitle3_pt: String,
        $carTripContent3: String,
        $carTripContent3_en: String,
        $carTripContent3_fr: String,
        $carTripContent3_it: String,
        $carTripContent3_pt: String,
        $isEnabled: Boolean
    ) {
      updateStaticInfoBlock (
        carTripTitle1: $carTripTitle1,
        carTripTitle1_en: $carTripTitle1_en,
        carTripTitle1_fr: $carTripTitle1_fr,
        carTripTitle1_it: $carTripTitle1_it,
        carTripTitle1_pt: $carTripTitle1_pt,
        carTripTitle2: $carTripTitle2,
        carTripTitle2_en: $carTripTitle2_en,
        carTripTitle2_fr: $carTripTitle2_fr,
        carTripTitle2_it: $carTripTitle2_it,
        carTripTitle2_pt: $carTripTitle2_pt,
        carTripContent2: $carTripContent2,
        carTripContent2_en: $carTripContent2_en,
        carTripContent2_fr: $carTripContent2_fr,
        carTripContent2_it: $carTripContent2_it,
        carTripContent2_pt: $carTripContent2_pt,
        carTripTitle3: $carTripTitle3,
        carTripTitle3_en: $carTripTitle3_en,
        carTripTitle3_fr: $carTripTitle3_fr,
        carTripTitle3_it: $carTripTitle3_it,
        carTripTitle3_pt: $carTripTitle3_pt,
        carTripContent3: $carTripContent3,
        carTripContent3_en: $carTripContent3_en,
        carTripContent3_fr: $carTripContent3_fr,
        carTripContent3_it: $carTripContent3_it,
        carTripContent3_pt: $carTripContent3_pt,
        isEnabled: $isEnabled
      ) {
          status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: mutation,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateStaticInfoBlock.status === "success") {
    showToaster({ messageId: 'blockSettingsUpdate', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'blockSettingsFailed', toasterType: 'error' })
  }

}

export default submit;
